import subscriptionPlan from './subscription_plan'

export default {
  components: {
    subscriptionPlan,
  },
  data() {
    return {
      optionPremium: [
        { id: 1, text: "Unlimited streaming" },
        { id: 2, text: "No Ads" },
        { id: 3, text: "Offline listening" },
        { id: 4, text: "Unlimited uploads (for creators)" },
      ],
      optionCreators: [
        { id: 1, text: "Unlimited streaming" },
        { id: 2, text: "No Ads" },
        { id: 3, text: "Offline listening" },
        { id: 4, text: "Unlimited uploads (for creators)" },
        { id: 5, text: "Analytics (for creators)" },
      ],
    };
  },
};



// WEBPACK FOOTER //
// ./src/views/settings/components/account_subscription.ctrl.js